import {deriveIdFromCanvasObject} from '~/common/canvas/utils/canvas';
import {CANVAS_HEIGHT} from '~/common/fabric/constants';
import type {FabricArt, FabricObject} from '~/common/fabric/types';

const isTextbox = (obj: FabricObject) => obj.type === 'textbox';

const isUyoImage = (obj: FabricObject) => obj.type === 'uYOImage';

const hasHeight = (obj: FabricObject) => Boolean(obj.height);

const isWithinCanvasHeight = (obj: FabricObject) =>
  obj.top !== undefined && obj.top < CANVAS_HEIGHT;

const isNotTooFarLeft = (obj: FabricObject) => obj.left > -(obj.width / 2);

const isActiveTextbox = (obj: FabricObject) =>
  isTextbox(obj) && hasHeight(obj) && isWithinCanvasHeight(obj) && isNotTooFarLeft(obj);

export const getUyoObjectIds = (fabricArt: FabricArt) =>
  fabricArt.objects
    .filter((obj) => isUyoImage(obj) && !obj.variant)
    .map((obj) => deriveIdFromCanvasObject(obj));

export const getLogoObjectIds = (fabricArt: FabricArt) =>
  fabricArt.objects
    .filter((obj) => isUyoImage(obj) && obj.variant === 'logo')
    .map((obj) => deriveIdFromCanvasObject(obj));

export const findActiveTextbox = (canvasObjects: FabricObject[]) =>
  canvasObjects?.find(isActiveTextbox);
